<div class="row">
  <div class="col-xs-12">
    <h5 class="no-margin" [innerHTML]="'$evaluation_discomfort_diagram_section_introduction_1' | translate"></h5>
    <p [innerHTML]="'$evaluation_discomfort_diagram_section_introduction_2' | translate"></p>
  </div>
</div>
<div class="row">
  <!-- Here isEvaluation  is boolean to update class -->
  <div class="col-xs-12" [ngClass]="isEvaluation === true? 'decrease-size':''"  *ngIf="data">
    <figure>
      <svg
        version="1.1"
        class="img-discomfort-map"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 572 429"
        style="enable-background:new 0 0 572 429;"
        xml:space="preserve">
        <g>
          <g id="img-bg">
            <defs>
              <rect id="SVGID_1_" width="572" height="429"/>
            </defs>
            <clipPath id="SVGID_2_">
              <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
            </clipPath>
            <g transform="matrix(1 0 0 1 0 0)" style="clip-path:url(#SVGID_2_);">
              <!-- Here calling  bodyDiagram global varible-->
              <image
                style="overflow:visible;"
                width="800"
                height="600"
                [attr.xlink:href]="bodyDiagram"
                transform="matrix(0.7125 0 0 0.715 0 0)" />
            </g>
          </g>

          <!-- clickable areas on body chart -->
          <circle *ngFor="let question of data.questions"
                  id="i-{{question.id}}"
                  class="hotspot"
                  [attr.cx]="bodyPartMapping[question.id].cx"
                  [attr.cy]="bodyPartMapping[question.id].cy"
                  r="10"
                  [matMenuTriggerFor]="menu"
                  [matMenuTriggerData]="{question: question}" />
        </g>
      </svg>
    </figure>
    <mat-menu #menu="matMenu" class="discomfort-menu">
      <ng-template matMenuContent let-question="question">
        <p class="body-part-menu-label">{{question.label}}</p>
        <ng-container *ngIf="!readOnly">
          <ng-container *ngFor="let answer of question.answers">
            <button mat-menu-item
                    md-autofocus
                    (click)="storeBodyPart(question, answer)">
              {{answer.label}}
              <span class="discomfort-{{answer.id}} discomfort-select">
                <span class="inner"></span>
              </span>
            </button>
          </ng-container>
        </ng-container>
      </ng-template>
    </mat-menu>
  </div>
</div>
<div class="row legend middle-xs center-xs">
  <div class="col-xs-2 end-xs">
    <span class="font-weight-bold legend-label" [innerHTML]="'$common_legend' | translate"></span>
  </div>
  <div class="col-xs-4 end-xs font-size-small">
      <span class="" [innerHTML]="'$common_discomfort_occasional' | translate"></span>
      <span class="discomfort-select discomfort-2">
        <span class="inner"></span>
      </span>
  </div>
  <div class="col-xs-3 end-xs font-size-small">
      <span class="" [innerHTML]="'$common_discomfort_frequent' | translate"></span>
      <span class="discomfort-select discomfort-3">
        <span class="inner"></span>
      </span>
  </div>
  <div class="col-xs-3 end-xs font-size-small">
      <span class="" [innerHTML]="'$common_discomfort_constant' | translate"></span>
      <span class="discomfort-select discomfort-4">
        <span class="inner"></span>
      </span>
  </div>
</div>